/* Velvet Hex 2.0 theme scripts — vanilla JS, no dependencies */
(function () {
  'use strict';

  var T = window.theme || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var isCartPage = document.body.classList.contains('template-cart');

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    var fmt = format || T.moneyFormat || '${{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function withDelims(n, precision, thousands, decimal) {
      precision = precision === undefined ? 2 : precision;
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return d + (parts[1] ? decimal + parts[1] : '');
    }
    var m = fmt.match(re);
    var key = m ? m[1] : 'amount';
    var v;
    switch (key) {
      case 'amount_no_decimals': v = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': v = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = withDelims(cents, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': v = withDelims(cents, 0, ' '); break;
      case 'amount_with_apostrophe_separator': v = withDelims(cents, 2, "'"); break;
      default: v = withDelims(cents, 2);
    }
    return fmt.replace(re, v);
  }

  /* ---------- Mobile menu & search ---------- */
  var menu = $('#MobileNav');
  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('menu-open', open);
    $$('[data-menu-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (open) { var c = $('[data-menu-close]', menu); if (c) c.focus(); }
  }
  document.addEventListener('click', function (e) {
    if (menu && menu.classList.contains('is-open') && !e.target.closest('#MobileNav') && !e.target.closest('[data-menu-toggle]')) { setMenu(false); return; }
    if (e.target.closest('[data-menu-toggle]')) { setMenu(true); return; }
    if (e.target.closest('[data-menu-close]')) { setMenu(false); return; }

    var st = e.target.closest('[data-search-toggle]');
    if (st) {
      var bar = $('[data-search-bar]');
      if (bar) {
        bar.hidden = !bar.hidden;
        if (!bar.hidden) { var i = $('input[type="search"]', bar); if (i) i.focus(); }
      }
      return;
    }

    var ft = e.target.closest('[data-filter-toggle]');
    if (ft) {
      var panel = $('[data-filter-panel]');
      if (panel) {
        panel.hidden = !panel.hidden;
        ft.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
      }
      return;
    }

    /* qty stepper on product page */
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var inp = step.closest('.qty').querySelector('input');
      var next = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10));
      inp.value = next;
      return;
    }

    /* cart open / close */
    var co = e.target.closest('[data-cart-open]');
    if (co && !isCartPage && $('#CartDrawer')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }

    /* quick add */
    var qa = e.target.closest('[data-quick-add]');
    if (qa) { e.preventDefault(); quickAdd(qa); return; }

    /* line quantity changes */
    var lq = e.target.closest('[data-line-qty]');
    if (lq) { e.preventDefault(); changeLine(parseInt(lq.getAttribute('data-line'), 10), parseInt(lq.getAttribute('data-qty'), 10)); return; }

    /* gallery thumbs */
    var th = e.target.closest('[data-thumb]');
    if (th) { scrollToSlide(parseInt(th.getAttribute('data-thumb'), 10)); return; }

    /* popup */
    if (e.target.closest('[data-popup-close]')) { closePopup(true); return; }

    /* sticky add to cart */
    if (e.target.closest('[data-sticky-btn]')) {
      var f = $('[data-product-form]');
      if (f) { if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); setMenu(false); closePopup(true); }
  });

  /* ---------- Cart drawer ---------- */
  var lastFocus = null;
  function openDrawer() {
    var d = $('#CartDrawer');
    if (!d) { window.location.href = T.cartUrl; return; }
    lastFocus = document.activeElement;
    document.body.classList.add('drawer-open');
    d.setAttribute('aria-hidden', 'false');
    var c = $('[data-cart-close]', d); if (c) c.focus();
  }
  function closeDrawer() {
    if (!document.body.classList.contains('drawer-open')) return;
    document.body.classList.remove('drawer-open');
    var d = $('#CartDrawer');
    if (d) d.setAttribute('aria-hidden', 'true');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-empty', n > 0 ? 'false' : 'true');
      el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
    });
  }

  function refreshCart(openAfter) {
    if (isCartPage) { window.location.reload(); return Promise.resolve(); }
    return fetch(T.root + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('cart-drawer section failed'); return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-drawer-inner]', doc);
        var current = $('[data-drawer-inner]');
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          setCount(parseInt(fresh.getAttribute('data-count'), 10) || 0);
        }
        if (openAfter) openDrawer();
      })
      .catch(function () { window.location.href = T.cartUrl; });
  }

  function changeLine(line, qty) {
    fetch(T.cartChangeUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function () { return refreshCart(false); });
  }

  function addToCart(body, isJson) {
    var opts = { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: body };
    if (isJson) opts.headers['Content-Type'] = 'application/json';
    return fetch(T.cartAddUrl + '.js', opts).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag'); return j; });
    });
  }

  function quickAdd(btn) {
    btn.classList.add('is-loading');
    addToCart(JSON.stringify({ id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1 }), true)
      .then(function () { return refreshCart(true); })
      .catch(function () { window.location.href = btn.closest('.card').querySelector('a').href; })
      .then(function () { btn.classList.remove('is-loading'); });
  }

  /* ajax add-to-cart on product form */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = $('[data-atc]', form);
    var err = $('[data-form-error]', form);
    if (err) err.hidden = true;
    var lbl = btn && $('[data-atc-label]', btn), pr = btn && $('[data-atc-price]', btn);
    var prevLabel = lbl ? lbl.textContent : '';
    if (btn) { btn.disabled = true; if (lbl) lbl.textContent = 'Adding...'; if (pr) pr.hidden = true; }
    addToCart(new FormData(form), false)
      .then(function () { return refreshCart(true); })
      .catch(function (ex) { if (err) { err.textContent = ex.message; err.hidden = false; } })
      .then(function () { if (btn) { btn.disabled = false; if (lbl) lbl.textContent = prevLabel || 'Add to bag'; if (pr) pr.hidden = false; } });
  });

  /* ---------- Product page ---------- */
  function scrollToSlide(i) {
    var main = $('[data-gallery-main]');
    if (!main) return;
    main.scrollTo({ left: i * main.clientWidth, behavior: 'smooth' });
  }

  function initProduct() {
    var section = $('[data-product-section]');
    if (!section) return;
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var invEl = $('[data-inventory-json]', section);
    var inv = {};
    if (invEl) { try { JSON.parse(invEl.textContent).forEach(function (v) { inv[v.id] = v.q; }); } catch (e) {} }
    var form = $('[data-product-form]', section);
    var idInput = $('[data-variant-id]', form);
    var atc = $('[data-atc]', form);
    var stickyBtn = $('[data-sticky-btn]');
    var atcLabel = atc && $('[data-atc-label]', atc);
    var atcPrice = atc && $('[data-atc-price]', atc);
    var priceEls = $$('[data-price]');
    var stockEl = $('[data-stock]', section);
    var main = $('[data-gallery-main]', section);
    var thumbs = $$('[data-thumb]', section);

    function selectedOptions() {
      return $$('[data-option-index]', form).map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }
    function findVariant(sel) {
      return product.variants.filter(function (v) {
        return [v.option1, v.option2, v.option3].slice(0, sel.length).every(function (o, i) { return o === sel[i]; });
      })[0];
    }
    function priceHtml(v) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        return '<span class="price"><span class="price-now is-sale">' + formatMoney(v.price) + '</span><s class="price-was">' + formatMoney(v.compare_at_price) + '</s></span><span class="badge badge-sale">Save ' + pct + '%</span>';
      }
      return '<span class="price"><span class="price-now">' + formatMoney(v.price) + '</span></span>';
    }
    function update() {
      var v = findVariant(selectedOptions());
      if (!v) {
        if (atcLabel) atcLabel.textContent = 'Unavailable';
        if (atcPrice) atcPrice.textContent = '';
        if (atc) { atc.disabled = true; }
        if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = 'Unavailable'; }
        return;
      }
      idInput.value = v.id;
      priceEls.forEach(function (el) { el.innerHTML = priceHtml(v); });
      var label = v.available ? 'Add to bag' : 'Sold out';
      if (atcLabel) atcLabel.textContent = label;
      if (atcPrice) atcPrice.innerHTML = v.available ? '&middot; ' + formatMoney(v.price) : '';
      if (atc) { atc.disabled = !v.available; }
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = label; }
      if (stockEl) {
        var q = inv[v.id];
        if (v.available && q != null && q > 0 && q <= (T.lowStock || 8)) {
          stockEl.textContent = 'Only ' + q + ' left' + (product.options.length === 1 && /size/i.test(product.options[0].name || product.options[0]) ? ' in this size' : '') + ' - selling fast';
          stockEl.hidden = false;
        } else { stockEl.hidden = true; }
      }
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
      }
      var mid = v.featured_media && v.featured_media.id;
      if (mid) {
        var slides = $$('[data-media-id]', section);
        for (var i = 0; i < slides.length; i++) {
          if (String(slides[i].getAttribute('data-media-id')) === String(mid)) { scrollToSlide(i); break; }
        }
      }
    }
    function markAvailability() {
      var fieldsets = $$('[data-option-index]', form);
      var sel = selectedOptions();
      fieldsets.forEach(function (fs, idx) {
        $$('.opt-input', fs).forEach(function (inp) {
          var test = sel.slice();
          test[idx] = inp.value;
          var ok = product.variants.some(function (v) {
            return v.available && [v.option1, v.option2, v.option3].slice(0, test.length).every(function (o, i) { return o === test[i]; });
          });
          inp.classList.toggle('is-soldout', !ok);
        });
      });
    }
    form.addEventListener('change', function (e) {
      if (e.target.matches('.opt-input')) { update(); markAvailability(); }
    });
    update();
    markAvailability();

    /* gallery: keep thumbs in sync */
    if (main && thumbs.length) {
      var raf;
      main.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(main.scrollLeft / main.clientWidth);
          thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        });
      }, { passive: true });
    }

    /* sticky ATC */
    var sticky = $('[data-sticky-atc]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(atc);
    }

    /* remember for "recently viewed" */
    try {
      var key = 'vh_recent';
      var list = JSON.parse(localStorage.getItem(key) || '[]').filter(function (h) { return h !== product.handle; });
      list.unshift(product.handle);
      localStorage.setItem(key, JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  }

  /* ---------- Recommendations ---------- */
  function initRecs() {
    $$('[data-recommendations]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-recommendations]', doc);
        if (fresh && fresh.innerHTML.trim().length) {
          el.innerHTML = fresh.innerHTML;
          var wrap = el.closest('[data-recs-section]');
          if (wrap) wrap.hidden = false;
        }
      }).catch(function () {});
    });
  }

  /* ---------- Recently viewed ---------- */
  function initRecent() {
    var host = $('[data-recent]');
    if (!host) return;
    var current = host.getAttribute('data-current');
    var list = [];
    try { list = JSON.parse(localStorage.getItem('vh_recent') || '[]'); } catch (e) {}
    list = list.filter(function (h) { return h !== current; }).slice(0, 4);
    if (!list.length) return;
    Promise.all(list.map(function (h) {
      return fetch(T.root.replace(/\/$/, '') + '/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      var html = items.filter(Boolean).map(function (p) {
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
        return '<article class="card"><div class="card-media"><a class="card-link" href="' + p.url + '" aria-label="' + p.title.replace(/"/g, '&quot;') + '">' +
          (img ? '<img class="card-img card-img-main" loading="lazy" alt="" src="' + img + '">' : '') +
          '</a></div><div class="card-info"><h3 class="card-title"><a href="' + p.url + '">' + p.title + '</a></h3><span class="price"><span class="price-now">' + formatMoney(p.price) + '</span></span></div></article>';
      }).join('');
      if (html) {
        $('[data-recent-grid]', host).innerHTML = html;
        host.hidden = false;
      }
    });
  }

  /* ---------- Countdown ---------- */
  function targetDate() {
    var t = new Date(T.halloweenDate || '2026-10-31T23:59:00');
    if (isNaN(t.getTime())) t = new Date(new Date().getFullYear(), 9, 31, 23, 59, 0);
    var now = new Date();
    while (t < now) t.setFullYear(t.getFullYear() + 1);
    return t;
  }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tickDeadline() {
    var els = $$('[data-deadline]');
    if (!els.length || !T.orderBy) return;
    var t = new Date(T.orderBy);
    if (isNaN(t.getTime())) return;
    var tpl = T.orderByText || 'Order within [time] to get it before Halloween';
    function run() {
      var diff = t - new Date();
      if (diff <= 0) { els.forEach(function (el) { el.hidden = true; }); return false; }
      var d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24, m = Math.floor(diff / 6e4) % 60, s = Math.floor(diff / 1e3) % 60;
      var txt = d > 0 ? d + 'd ' + pad(h) + 'h ' + pad(m) + 'm' : pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
      els.forEach(function (el) {
        var out = $('[data-deadline-text]', el);
        if (!out) return;
        var parts = tpl.split('[time]');
        out.textContent = '';
        out.appendChild(document.createTextNode(parts[0]));
        if (parts.length > 1) {
          var b = document.createElement('b'); b.textContent = txt; out.appendChild(b);
          out.appendChild(document.createTextNode(parts.slice(1).join('[time]')));
        }
        el.hidden = false;
      });
      return true;
    }
    if (run()) var iv = setInterval(function () { if (!run()) clearInterval(iv); }, 1000);
  }

  function tickCountdowns() {
    var els = $$('[data-countdown]');
    if (!els.length) return;
    var t = targetDate();
    function run() {
      var diff = Math.max(0, t - new Date());
      var d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24, m = Math.floor(diff / 6e4) % 60, s = Math.floor(diff / 1e3) % 60;
      els.forEach(function (el) {
        var map = { d: d, h: pad(h), m: pad(m), s: pad(s) };
        $$('[data-unit]', el).forEach(function (u) { u.textContent = map[u.getAttribute('data-unit')]; });
      });
    }
    run();
    setInterval(run, 1000);
  }

  /* ---------- Collection filters ---------- */
  function initFilters() {
    var f = $('[data-filter-form]');
    if (!f) return;
    f.addEventListener('change', function (e) {
      if (e.target.closest('[data-auto-submit]') || e.target.matches('.check input')) f.submit();
    });
  }

  /* ---------- Email popup ---------- */
  var popup = $('[data-popup]');
  function openPopup() {
    if (!popup) return;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    var c = $('[data-popup-close]', popup); if (c) c.focus();
  }
  function closePopup(remember) {
    if (!popup || !popup.classList.contains('is-open')) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    if (remember) { try { localStorage.setItem('vh_popup', '1'); } catch (e) {} }
  }
  function initPopup() {
    if (!popup) return;
    if (popup.hasAttribute('data-posted')) { openPopup(); try { localStorage.setItem('vh_popup', '1'); } catch (e) {} return; }
    var skip = /template-(cart|password|customers)/.test(document.body.className);
    var seen = false;
    try { seen = !!localStorage.getItem('vh_popup'); } catch (e) {}
    if (skip || seen || window.Shopify && Shopify.designMode) return;
    var delay = parseInt(popup.getAttribute('data-delay'), 10) || 8;
    setTimeout(function () {
      if (!document.body.classList.contains('drawer-open')) openPopup();
    }, delay * 1000);
  }

  /* ---------- Announcement rotator ---------- */
  function initRotator() {
    var host = $('[data-rotator]');
    if (!host) return;
    var msgs = $$('.ann-msg', host);
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 4500);
  }

  /* ---------- Product tabs ---------- */
  function initTabs() {
    $$('[data-tabs]').forEach(function (root) {
      var tabs = $$('[data-tab]', root);
      if (!tabs.length) return;
      function show(id) {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-tab') === id ? 'true' : 'false'); });
        $$('[data-panel]', root).forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== id; });
      }
      tabs.forEach(function (t, k) {
        t.addEventListener('click', function () { show(t.getAttribute('data-tab')); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var n = tabs[(k + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          n.focus(); show(n.getAttribute('data-tab'));
        });
      });
    });
  }

  /* ---------- Exit-intent popup (desktop) ---------- */
  function initExitIntent() {
    if (!popup || !T.exitIntent) return;
    if (/template-(cart|password|customers)/.test(document.body.className)) return;
    if (window.Shopify && Shopify.designMode) return;
    var seen = false;
    try { seen = !!localStorage.getItem('vh_popup'); } catch (e) {}
    if (seen) return;
    var armed = false;
    setTimeout(function () { armed = true; }, 5000);
    document.addEventListener('mouseout', function onOut(e) {
      if (!armed || e.relatedTarget || e.clientY > 10) return;
      if (document.body.classList.contains('drawer-open')) return;
      openPopup();
      document.removeEventListener('mouseout', onOut);
    });
  }

  /* ---------- Boot ---------- */
  function init() {
    initProduct(); initRecs(); initRecent(); tickCountdowns(); tickDeadline(); initFilters(); initPopup(); initExitIntent(); initRotator(); initTabs();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
